import Vue from 'vue'
import Import from './Import.vue'
import CardFinancial from './CardFinancial.vue'

const ImportComponent = Vue.extend(Import)
const CardFinancialComponent = Vue.extend(CardFinancial)

export default {
  openImport (propsData) {
    return new ImportComponent({
      el: document.createElement('div'),
      propsData
    })
  },
  cardFinancial (propsData) {
    return new CardFinancialComponent({
      el: document.createElement('div'),
      propsData
    })
  }
}



// WEBPACK FOOTER //
// ./client/components/services/services.js